module.exports = __webpack_public_path__ + "img/txnFailed.c4717516.svg";